<template>
  <div @click="handleClick" class="alert glass-element">
    <header @click="handleClick" :class="className">
      <div><b-icon icon="icon"></b-icon></div>
    </header>
    <div class="alert-content">
      <div>{{ message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type", "message", "handleClick"],
  computed: {
    className() {
      return `${this.type}-alert-header`;
    },
    icon() {
      return this.type === "success"
        ? "check"
        : this.type === "warning"
        ? "bell-outline"
        : "mdi-close";
    },
  },
};
</script>
